import { doFetch } from "./apiFetchHelper";

export const getAllCategories = () => {
  const apiUrl = "/api/categories";

  return doFetch(apiUrl);
};
